/*
API requests related to assets
*/
import { apiRequest } from '../../plugins/core/dd.data.connect.js'

export const getDashboardStats = (data, params) => {
    var p = new Promise((resolve, reject) => {
        
        apiRequest('GET', `/dashboard/stats`, null, params).then((res) => {
          resolve(res.data)
        }).catch((e) => {
          reject(e)
        })
      })
      return p
  }
  
  
export const getHardwareEventPresets = (data, params) => {
  var p = new Promise((resolve, reject) => {     
        if(!data.hardwareId)
          reject({'data': 'no hardwareId given'});
        if(!data.eventType)
          reject({'data': 'no eventType given'});
              
        apiRequest('GET', `/hardware/${data.hardwareId}/event-presets/${data.eventType}`, null, params).then((res) => {
          resolve(res.data)
        }).catch((e) => {
          reject(e)
        })
    })
    return p
}

export const sendUserMessage = (data, params) => {
  var p = new Promise((resolve, reject) => {                     
        apiRequest('POST', `/messages/users/${data.toUserId}`, data, params).then((res) => {
          resolve(res.data)
        }).catch((e) => {
          reject(e)
        })
    })
    return p
}

export const saveTimeTable = (data, params) => {
  var p = new Promise((resolve, reject) => {     
        let method = "POST"
        let url    = "/time-tables"
        if(data.id){
          method = "PUT"
          url    += "/"+data.id
        }      
        apiRequest(method, url, data, {}).then((res) => {
          resolve(res.data)
        }).catch((e) => {
          reject(e)
        })
    })
    return p
}

export const deleteTimeTable = (data, params) => {
  var p = new Promise((resolve, reject) => {     
        if(!data.id){
          reject("No id given")
        }

        let method = "DELETE"
        let url    = "/time-tables/"+data.id
 
        apiRequest(method, url, null, {}).then((res) => {
          resolve(res.data)
        }).catch((e) => {
          reject(e)
        })
    })
    return p
}


export const getTimeTables = (data, params) => {
  var p = new Promise((resolve, reject) => {     

        apiRequest('GET', `/time-tables`, null, params).then((res) => {
          resolve(res.data)
        }).catch((e) => {
          reject(e)
        })
    })
    return p
}


export const getSystemMessages = (data, params) => {
  var p = new Promise((resolve, reject) => {     

        apiRequest('GET', `/messages/systems`, null, params).then((res) => {
          resolve(res.data)
        }).catch((e) => {
          reject(e)
        })
    })
    return p
}

export const getApplicationSystemMessages = (data, params) => {
  var p = new Promise((resolve, reject) => {     

        apiRequest('GET', `/messages/systems/${data.applicationId}`, null, params).then((res) => {
          resolve(res.data)
        }).catch((e) => {
          reject(e)
        })
    })
    return p
}



export const getOveralSystemMessagesMeta = (data, params) => {
  var p = new Promise((resolve, reject) => {     

        apiRequest('GET', `/messages/systems/meta`, null, params).then((res) => {          
          resolve(res.data)
        }).catch((e) => {
          reject(e)
        })
    })
    return p
}

export const getUserMessagesMeta = (data, params) => {
  var p = new Promise((resolve, reject) => {     

        apiRequest('GET', `/messages/users/meta`, null, params).then((res) => {          
          resolve(res.data)
        }).catch((e) => {
          reject(e)
        })
    })
    return p
}

export const getUserMessages = (data, params) => {
  var p = new Promise((resolve, reject) => {     

        apiRequest('GET', `/messages/users/${data.userId}`, null, params).then((res) => {          
          resolve(res.data)
        }).catch((e) => {
          reject(e)
        })
    })
    return p
}